<template>
  <div>
    <div class="title-bar">
      <h1>{{ isUpdate ? 'Редактировать SEO шаблон Тематическая страница + Город' : 'Создать SEO шаблон Тематическая страница + Город' }}</h1>

      <div class="title-bar__button-wrapper">
        <router-link class="button-wrapper-link" :to="{name: 'SeoTemplatesTopicList'}">
          <el-button type="info">
            <i class="fas fa-list" /> Список
          </el-button>
        </router-link>

        <el-button type="primary" @click="$refs.form.onSubmit()">
          Сохранить
        </el-button>
      </div>
    </div>

    <div class="panel">
      <div class="panel-body">
        <Form ref="form" />
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/components/seo-templates-topic/Form'

export default {
  name: 'CreateUpdateSeoTopicTemplatePage',
  metaInfo: {
    title: 'Создать/Редактировать SEO шаблон Тематическая страница + Город',
  },
  components: {Form},
  computed: {
    isUpdate() {
      return this.$route.name === 'UpdateSeoTopicTemplate'
    },
  },
}
</script>

<style lang="sass" scoped>
.seo-templates-form
  padding: 20px

.seo-templates-form__form
  max-width: 600px
  margin: 0 auto

.seo-templates-form__upload-image
  margin-bottom: 10px

.seo-templates-form__preview
  max-width: 200px
  max-height: 200px
  object-fit: contain
</style>


